import { jsxs, jsx } from "react/jsx-runtime";
import { Flex, Box } from "@zillow/constellation";
import { useState, useEffect } from "react";
import { omitUndefined } from "../../utils/lodash.esm.js";
import MortgagePageClassification from "../../utils/mortgagehelpers/MortgagePageClassification.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import LegalDisclosuresModal from "../LegalDisclosuresModal/LegalDisclosuresModal.esm.js";
import { getMortgageRates } from "../LegalDisclosuresModal/constants.esm.js";
import { OPTIONS_TIMESPAN, OPTIONS_LTV, CREDIT_SCORE_BUCKETS, OPTIONS_LOAN_TYPE, FieldConfig } from "./MortgageRateTrends.utils.esm.js";
import MortgageRateTrendsChart from "./MortgageRateTrendsChart.esm.js";
import MortgageRateTrendsFields from "./MortgageRateTrendsFields.esm.js";
const MortgageRateTrends = ({
  defaultValues,
  editorMode,
  pathName
}) => {
  const classification = new MortgagePageClassification(pathName ? pathName : "/mortgage-rates/");
  const [rates, setRates] = useState({});
  const finalDefaultValues = {
    // Default values
    [FieldConfig.loanPurpose.name]: OPTIONS_LOAN_TYPE.Purchase,
    [FieldConfig.creditRating.name]: CREDIT_SCORE_BUCKETS.VeryHigh,
    [FieldConfig.Fixed30Year.name]: true,
    [FieldConfig.location.name]: "United States",
    [FieldConfig.percentDown.name]: OPTIONS_LTV.Normal,
    [FieldConfig.timeSpan.name]: OPTIONS_TIMESPAN.OneYear,
    // Custom default values
    ...omitUndefined(defaultValues)
  };
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await getMortgageRates(pathName);
        setRates(response);
      } catch (error) {
        console.error("Error fetching mortgage rates:", error);
      }
    };
    fetchRates();
  }, [pathName]);
  return /* @__PURE__ */ jsxs(CalculatorForm, { fieldStorageKey: "mortgageratetrendsfields", defaultValues: finalDefaultValues, editorMode, children: [
    /* @__PURE__ */ jsxs(Flex, { display: "flex", flexDirection: {
      default: "column",
      xxl: "row"
    }, children: [
      /* @__PURE__ */ jsx(Flex, { marginRight: {
        xxl: "xs"
      }, order: {
        default: 2,
        xxl: 1
      }, children: /* @__PURE__ */ jsx(MortgageRateTrendsFields, {}) }),
      /* @__PURE__ */ jsx(Flex, { tabindex: "0", flex: "1", order: {
        default: 1,
        xxl: 2
      }, as: "figure", role: "group", children: /* @__PURE__ */ jsx(MortgageRateTrendsChart, {}) })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      marginTop: "$spacing.sm"
    }, children: /* @__PURE__ */ jsx(LegalDisclosuresModal, { classification, rates }) })
  ] });
};
export {
  MortgageRateTrends as default
};
